import { IEventEnrollment } from '../eventEnrollments/store';

export interface IPlayerEditorModalStore {
  modalIsOpen: boolean;
  enrollment?: IEventEnrollment;
}

export const playerEditorModalStore: IPlayerEditorModalStore = {
  modalIsOpen: false
};
